import { UserPublicData } from "@scrile/api-provider/dist/projects/webvideo/UserPublicDataProvider";
import { openPopupWidget } from "react-calendly";
import { Prefill } from "react-calendly/typings/calendly";
import useAuthUser from "hooks/useAuthUser";
import useModalLinkPrinter from "hooks/useModalLinkPrinter";
import emitter, { EVENTS } from "lib/emitter";
import { Routes } from "../../router/config";

const useController = (providerUser: UserPublicData, scheduleUrl: string) => {
  const { user: loggedUser } = useAuthUser();
  const { getLocation } = useModalLinkPrinter();
  const loginLink = loggedUser ? undefined : getLocation(Routes.login);

  const prefill: Prefill = {
    email: loggedUser?.email || "",
    name: loggedUser?.screenName || "",
  };

  const onClickButton = () => {
    openPopupWidget({ url: scheduleUrl, prefill });
    emitter.emit(EVENTS.SET_BOOKING_USER, providerUser);
  };

  return {
    loginLink,
    onClickButton,
  };
};

export default useController;
